import React, { useState } from "react";
import GetAppIcon from "@mui/icons-material/GetApp";

import { Button, ButtonProps, CircularProgress } from "@mui/material";

import { logger } from "@/helpers/loggerHelper";

import { toastr } from "react-redux-toastr";
import { downloadCSVFile } from "@/helpers/utils";

interface DownloadLinkButtonProps
  extends Omit<ButtonProps, "children" | "color"> {
  buttonText?: React.ReactNode;
  customStyle?: React.CSSProperties;
  downloadLink?: string;
  color?: ButtonProps["color"] | "dark";
  getDownloadUrl?: () => Promise<string | Blob | null | undefined>;
}

const DownloadLinkButton = ({
  buttonText = "Download Template",
  startIcon = <GetAppIcon />,
  className = "",
  size = "small",
  customStyle,
  downloadLink = "",
  color = "dark",
  variant = "contained",
  getDownloadUrl = async () => undefined,
}: DownloadLinkButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleDownload = async () => {
    try {
      setIsLoading(true);

      await new Promise((resolve) => setTimeout(resolve, 3000)); // Delay for 3 seconds

      if (downloadLink) {
        window.open(downloadLink, "_blank");
      }

      const dynamicDownloadLink = await getDownloadUrl();
      if (dynamicDownloadLink) {
        downloadCSVFile(dynamicDownloadLink, "Budget Sheet.csv", "text/csv");
      }
      toastr.success("Success", "Downloaded successfully!");
    } catch (error) {
      logger.error("Error fetching the download URL:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && (
        <div className="loading-overlay">
          <CircularProgress color="primary" />
        </div>
      )}
      <Button
        variant={variant}
        onClick={handleDownload}
        startIcon={startIcon}
        size={size}
        disableElevation
        className={`${className} cursor-p`}
        color={color as ButtonProps["color"]}
        style={customStyle}
      >
        {buttonText}
      </Button>
    </>
  );
};

export default DownloadLinkButton;
